import { Injectable } from "@angular/core";
import { ChangeTitlePayload } from "@shared/generalInterfaces";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class StickyHeaderService {
    titleChanged$: BehaviorSubject<ChangeTitlePayload> = new BehaviorSubject<ChangeTitlePayload>({title: '', logo: '', logoFallback: ''});    
    screenshotsEnabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}